<template>
  <div>
    <transition name="slide-fade" appear>
      <b-card no-body class="overflow-hidden" style="max-width: 540px; margin: auto; margin-top: 5%" footer-bg-variant="white" v-show="verLogin">
        <b-row no-gutters>
          <b-col md="6">
            <b-card-img :src="imagenlogin" height="100%" class="rounded-0"></b-card-img>
          </b-col>
          <b-col md="6">
            <b-card-body title="Iniciar Sesión">
              <b-card-text>
                <hr>
                <b-form @submit.prevent="enviarFormulario">
                  <b-input-group label="Usuario" class="text-14 mb-4">
                    <b-input-group-prepend>
                        <b-input-group-text><b-icon-person-fill></b-icon-person-fill></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input class="form-control" type="text" v-model="usuario" ref="usuario" placeholder="Usuario" autofocus required></b-form-input>
                  </b-input-group>
                  <b-input-group label="Contraseña" class="text-14">
                    <b-input-group-prepend>
                        <b-input-group-text><b-icon-lock-fill></b-icon-lock-fill></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input class="form-control" type="password" v-model="password" placeholder="Contraseña" required></b-form-input>
                  </b-input-group>
                  <b-button type="submit" tag="button" class="btn btn-block mt-4" variant="primary mt-2" :disabled="cargando">Ingresar</b-button>
                </b-form>
                <div class="text-right">
                  <router-link to="forgot" tag="a" class="text-muted">
                    <small>¿Recordar la contraseña?</small>
                  </router-link>
                </div>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>            
        <template v-slot:footer v-if="cargando">
          <div class="text-center">
            <b-icon icon="arrow-clockwise" animation="spin-pulse" font-scale="4"></b-icon>
          </div>
        </template>
      </b-card>
    </transition>
    <transition>
      <b-card no-body class="overflow-hidden" style="max-width: 540px; margin: auto; margin-top: 5%" v-show="verBienvenida">
        <b-row no-gutters>
          <b-col md="12">
            <b-card bg-variant="light" header="Datos de la Sesión">
              <b-card-text>
                <b-form @submit.prevent="iniciarSesion">
                  <b-row>
                    <b-col lg="7" md="7">
                      <p>Usuario:<br><strong>{{ registroSesion.usuario }}</strong></p>
                      <p>Nombres:<br><strong>{{ registroSesion.nombres }}</strong></p>
                      <p>Apellidos:<br><strong>{{ registroSesion.apellidos }}</strong></p>
                      <p>Perfil:<br><strong>{{ registroSesion.perfil }}</strong></p>
                    </b-col>
                    <b-col lg="5" md="5" class="text-center">
                      <b-img :src="escudo" rounded="circle" fluid></b-img>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-button type="submit" tag="button" class="btn-block mr-4 px-5" variant="success" @click="sesion(registroSesion)">
                    <b-icon-unlock-fill></b-icon-unlock-fill> Continuar
                  </b-button>
                </b-form>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <template v-slot:footer v-if="cargando">
          <div class="text-center">
            <b-icon icon="arrow-clockwise" animation="spin-pulse" font-scale="4"></b-icon>
          </div>
        </template>
      </b-card>
    </transition>
    <PiePagina/>
  </div>
</template>
<script>
  import axios from 'axios'
  import * as CONFIG from '@/assets/config.js'
  import PiePagina from '@/components/pies/PiePagina'
  import {mapState, mapMutations} from 'vuex'
  import municipios from "@/assets/tablas/municipios.js";
  import perfiles from "@/assets/tablas/perfiles.js";
  import categorias from "@/assets/tablas/categorias.js";

  export default {
    data() {
      return {
        usuario: '',
        password: '',
        cargando: false,
        imagenlogin: require('@/assets/imagenes/imagen-login.jpg'),
        escudo: '',
        logo: require('@/assets/logo.png'),
        registroSesion: {
          idUsuario: 0,
          usuario: '',
          nombres: '',
          apellidos: '',
          idPerfil: 0,
          perfil: '',
          idColegio: 0,
          dane: '',
          nit: '',
          nombre: '',
          categoria: '',
          nemo: '',
          resolucion: '',
          direccion: '',
          municipio: '',
          departamento: '',
          telefono: '',
          correo: '',
          bd: '',
          foto:'',
          lectivo: 0,
          idCurso: ''
        },
        verLogin: false,
        verBienvenida: true        
      };
    },
    computed: {
      ...mapState(['datosSesion'])
    },
    methods: {
      ...mapMutations(['sesion']),
      iniciarSesion() {
        this.cargando = true
        sessionStorage.setItem('token', this.registroSesion.idUsuario)
        this.$router.push("/")
      },
      enviarFormulario() {
        this.cargando = true
        if (sessionStorage.getItem("idModulo") != null && sessionStorage.getItem("idModulo").length > 0 && sessionStorage.getItem("idColegio") != null && sessionStorage.getItem("idColegio").length > 0 && sessionStorage.getItem("bdColegio") != null && sessionStorage.getItem("bdColegio").length > 0) {
          let idModulo = sessionStorage.getItem("idModulo")
          let idColegio = sessionStorage.getItem("idColegio")
          let bdColegio = sessionStorage.getItem("bdColegio")
          if (idModulo == 2) {
            // Modulo Perfil 6: Docente
            axios
            .get(CONFIG.ROOT_PATH + 'validarCredencialesDocente', { params: { usuario: this.usuario, clave: this.password, idColegio: idColegio, bdColegio: bdColegio }})
            .then(response => {
              //console.log(JSON.stringify(response.data))
              if (response.data.error){
                this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
                this.usuario = ''
                this.password = ''
                this.$refs.usuario.focus()
                this.cargando = false
              } else{            
                this.registroSesion.idUsuario = response.data.datos.id_docente
                this.registroSesion.usuario = response.data.datos.usuario
                this.registroSesion.nombres = response.data.datos.nombres
                this.registroSesion.apellidos = response.data.datos.apellidos
                this.registroSesion.idPerfil = response.data.datos.id_perfil
                this.registroSesion.idColegio = idColegio
                this.registroSesion.bd = bdColegio
                this.registroSesion.foto = response.data.datos.foto
                //this.registroSesion.lectivo = response.data.datos.lectivo
                this.registroSesion.lectivo = 2020
                if (idColegio == 2) {
                  this.registroSesion.categoria = 'Institución Educativa'
                  this.registroSesion.nombre = 'Bellas Artes'
                }
                this.registroSesion.perfil = 'Docente'
                this.escudo = require('@/assets/escudos/es' + idColegio + '.jpg')
                this.verLogin = false
                setTimeout(() => {
                  this.verBienvenida = true
                  this.cargando = false
                }, 1000)
              }
            })
            .catch(err => {
              if (err.message === 'Network Error')
                this.mensajeEmergente('danger','Mensaje','Conexión denegada!. Por favor contáctese con el administrador.');
              else
                this.mensajeEmergente('danger','Mensaje','Se ha detectado un error inesperado!. Por favor contáctese con el administrador. ' + err.message);
              this.usuario = ''
              this.password = ''
              this.$refs.usuario.focus()
              this.cargando = false
            })
          } else if (idModulo == 3) {
            // Modulo Perfil 7: Estudiante
            axios
            .get(CONFIG.ROOT_PATH + 'validarCredencialesEstudiante', { params: { usuario: this.usuario, clave: this.password, idColegio: idColegio, bdColegio: bdColegio }})
            .then(response => {
              //console.log(JSON.stringify(response.data))
              if (response.data.error){
                this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
                this.usuario = ''
                this.password = ''
                this.$refs.usuario.focus()
                this.cargando = false
              } else{            
                this.registroSesion.idUsuario = response.data.datos.id_matricula
                this.registroSesion.usuario = response.data.datos.documento
                this.registroSesion.nombres = response.data.datos.nombres
                this.registroSesion.apellidos = response.data.datos.apellidos
                this.registroSesion.idPerfil = 7
                this.registroSesion.idColegio = idColegio
                this.registroSesion.bd = bdColegio
                this.registroSesion.foto = response.data.datos.foto
                //this.registroSesion.lectivo = response.data.datos.lectivo
                this.registroSesion.lectivo = 2020
                this.registroSesion.idCurso = response.data.datos.id_curso
                alert(response.data.datos.id_curso)
                if (idColegio == 2) {
                  this.registroSesion.categoria = 'Institución Educativa'
                  this.registroSesion.nombre = 'Bellas Artes'
                }
                this.registroSesion.perfil = 'Estudiante'
                this.escudo = require('@/assets/escudos/es' + idColegio + '.jpg')
                this.verLogin = false
                setTimeout(() => {
                  this.verBienvenida = true
                  this.cargando = false
                }, 1000)
              }
            })
            .catch(err => {
              if (err.message === 'Network Error')
                this.mensajeEmergente('danger','Mensaje','Conexión denegada!. Por favor contáctese con el administrador.');
              else
                this.mensajeEmergente('danger','Mensaje','Se ha detectado un error inesperado!. Por favor contáctese con el administrador. ' + err.message);
              this.usuario = ''
              this.password = ''
              this.$refs.usuario.focus()
              this.cargando = false
            })
          } else {
            this.mensajeEmergente('danger','Mensaje','El módulo Aula Virtual no esta habilitado en la Institución.');
            this.usuario = ''
            this.password = ''
            this.$refs.usuario.focus()
            this.cargando = false
          }
        } else {
          this.mensajeEmergente('danger','Mensaje','El módulo Aula Virtual no esta habilitado en la Institución.');
          this.usuario = ''
          this.password = ''
          this.$refs.usuario.focus()
          this.cargando = false
        }
        /*
        axios
        .get(CONFIG.ROOT_PATH + rutaConsultaApi, { params: { usuario: this.usuario, clave: this.password }})
        .then(response => {
          //console.log(JSON.stringify(response.data))
          if (response.data.error){
            this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
            this.usuario = ''
            this.password = ''
            this.$refs.usuario.focus()
            this.cargando = false
          } else{            
            this.registroSesion.idUsuario = response.data.datos.id
            this.registroSesion.usuario = response.data.datos.usuario
            this.registroSesion.nombres = response.data.datos.nombres
            this.registroSesion.apellidos = response.data.datos.apellidos
            this.registroSesion.idPerfil = response.data.datos.id_perfil
            perfiles.forEach(fila => {
              if(fila.id == response.data.datos.id_perfil){
                this.registroSesion.perfil = fila.perfil
              }
            })
            this.registroSesion.idColegio = response.data.datos.id_colegio
            this.registroSesion.dane = response.data.datos.dane
            this.registroSesion.nit = response.data.datos.nit
            this.registroSesion.nombre = response.data.datos.nombre
            categorias.forEach(fila => {
              if(fila.id == response.data.datos.id_categoria){
                this.registroSesion.categoria = fila.categoria
              }
            })
            this.registroSesion.nemo = response.data.datos.nemo
            this.registroSesion.resolucion = response.data.datos.resolucion
            this.registroSesion.direccion = response.data.datos.direccion
            municipios.forEach(fila => {
              if(fila.id == response.data.datos.id_municipio){
                this.registroSesion.municipio = fila.municipio
                this.registroSesion.departamento = fila.departamento
              }
            })
            this.registroSesion.telefono = response.data.datos.telefono
            this.registroSesion.correo = response.data.datos.correo
            this.registroSesion.bd = response.data.datos.bd
            this.registroSesion.foto = response.data.datos.foto
            //this.registroSesion.lectivo = response.data.datos.lectivo
            this.registroSesion.lectivo = 2019

            this.escudo = require('@/assets/escudos/es' + this.registroSesion.idColegio + '.jpg')
            this.verLogin = false
            setTimeout(() => {
              this.verBienvenida = true
              this.cargando = false
            }, 1000)
          }
        })
        .catch(err => {
          if (err.message === 'Network Error')
            this.mensajeEmergente('danger','Mensaje','Conexión denegada!. Por favor contáctese con el administrador.');
          else
            this.mensajeEmergente('danger','Mensaje','Se ha detectado un error inesperado!. Por favor contáctese con el administrador. ' + err.message);
          this.usuario = ''
          this.password = ''
          this.$refs.usuario.focus()
          this.cargando = false
        })
        */
      },
      iniciarFormulario(){
        this.usuario = ''
        this.password = ''
        this.verBienvenida = false
        this.verLogin = true
        this.cargando = false
        sessionStorage.removeItem('token')
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: 'b-toaster-top-center', solid: true, autoHideDelay: 4000, appendToast: false });
      }
    },
    beforeMount() {
      this.iniciarFormulario()
    },
    components: {
      PiePagina
    }
  }
</script>

<style>
  .spinner.sm {
    height: 2em;
    width: 2em;
  }
</style>